import { Alert, Box, Button, Grid } from "@mui/material";
import Logger from "../../../services/Logger";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import CustomAddButton from "../../components/CustomAddButton";
import ConfirmDialog from "../../components/ConfirmDialog";
import CustomSnackbar from "../../components/CustomSnackbar";
import TopicList from "./TopicList";
import TopicService from "./TopicService";

export default function AdminTopicMain() {
    const navigate = useNavigate();

    const [keyword] = useState("");
    const [showConfirmDialog, setShowConfirmDialog] = useState(false);
    const [cleaningUp, setCleaningUp] = useState(false);
    const [openSnackbar, setOpenSnackbar] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState("");
    const [snackbarSeverity, setSnackbarSeverity] = useState("success");

    useEffect(() => {}, []);

    const handleAdd = () => {
        navigate("/admin/topic/create");
    };

    const handleCleanUp = () => {
        setShowConfirmDialog(true);
    };

    const confirmCleanUp = async (targetId) => {
        try {
            setCleaningUp(true);
            const result = await TopicService.cleanupUnrelatedTopics();
            
            if (result && result.deletedCount !== undefined) {
                setSnackbarMessage(result.message || `Cleanup completed. Deleted ${result.deletedCount} unrelated topics.`);
                setSnackbarSeverity("success");
                setOpenSnackbar(true);
                
                // Refresh the topic list by reloading the page or refreshing data
                window.location.reload();
            } else {
                setSnackbarMessage("Cleanup completed, but no count was returned.");
                setSnackbarSeverity("warning");
                setOpenSnackbar(true);
            }
        } catch (err) {
            Logger.error("Error cleaning up unrelated topics:", err);
            setSnackbarMessage(err.message || "Failed to clean up unrelated topics");
            setSnackbarSeverity("error");
            setOpenSnackbar(true);
        } finally {
            setCleaningUp(false);
        }
    };

    return (
        <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2, pr: 2 }}>
                <Button
                    variant="outlined"
                    color="warning"
                    onClick={handleCleanUp}
                    disabled={cleaningUp}
                    sx={{ minWidth: 120 }}
                >
                    {cleaningUp ? "Cleaning Up..." : "Clean Up"}
                </Button>
            </Box>
            <Grid container sx={{ flexGrow: 1 }}>
                <Grid size={{ xs: 12 }}>
                    <TopicList keyword={keyword} />
                </Grid>
            </Grid>
            <CustomAddButton title="Add Topic" onClick={handleAdd} />
            
            <ConfirmDialog
                open={showConfirmDialog}
                setOpen={setShowConfirmDialog}
                title="Confirm Clean Up"
                message="Are you sure you want to clean up unrelated topics? This action will delete all topics that are not associated with any puzzles. This action cannot be undone."
                callback={confirmCleanUp}
            />

            <CustomSnackbar
                open={openSnackbar}
                setOpen={setOpenSnackbar}
                message={snackbarMessage}
                severity={snackbarSeverity}
            />
        </Box>
    );
}
